import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import Header from '../../components/Headers/Header';
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { InstituicaoContext } from "../../context/InstituicaoContext";
import { InstituicaoType, EditInstituicaoType } from "../../context/hooks/useInstituicao";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import ModalChangePassword from "../../components/ModalChangePassword/ModalChangePassword";

const ProfileInstituicao = () => {
  const { handleGetInstituicaoById, instituicao, setInstituicao, updateInstituicao } = useContext(InstituicaoContext);
  const { objUserTk } = useContext(AuthContext);

  const [editPerfilState, setEditPerfilState] = useState<boolean>(true);
  const photoInputRef = useRef<HTMLInputElement>(null);
  const [openModalChangePassword, setOpenModalChangePassword] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await handleGetInstituicaoById(objUserTk.EmpresaId);
    };

    fetchData();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setInstituicao((prevInstituicao: InstituicaoType | null) => {
      if (!prevInstituicao) return prevInstituicao;
      return {
        ...prevInstituicao,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  const handleSalveIndoInstituicao = async (update: InstituicaoType) => {
    const updateData: EditInstituicaoType = {
      id: instituicao.id,
      name: update.name,
      email: update.email,
      password: "",
    };
    await updateInstituicao(updateData);
    await handleGetInstituicaoById(objUserTk.EmpresaId);
    setEditPerfilState(true);
  };

  // const handleClickChangePhoto = () => {
  //   if (photoInputRef.current) {
  //     photoInputRef.current.click();
  //   }
  // };

  // const handleFileChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ): void => {
  //   const file = event.target.files?.[0];

  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       const contentBase64 = e.target?.result as string;
  //       if (file.type.startsWith("image/")) {
  //         setUser((prevUser) => ({
  //           ...prevUser,
  //           office: {
  //             ...prevUser.office,
  //             photo: contentBase64,
  //           },
  //         }));
  //       } else {
  //         alert("Tipo de arquivo não suportado:");
  //       }
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  return (
    <>
      <Header />
      <LoadingSpinner />
      <AdminNavbar brandText={"MEU PERFIL"} search={false} titleSearch={""} />
      <Container className="mt--3" fluid>
        <Row>
          {/* <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
            <Card className="card-profile shadow">
              <Row className="justify-content-end">
                <Col className="order-lg-2" lg="6">
                  <div className="card-profile-image">
                    <div className="card-candidate-content">
                      <div className="card-profile-image-recruiter ">
                        <img
                          style={{
                            objectFit: "cover",
                            objectPosition: "center center",
                          }}
                          alt="Avatar"
                          className="img-fluid rounded-circle"
                          src={
                            user.office.photo ||
                            require("../../assets/img/theme/profile.png")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                <div className="d-flex justify-content-between">
                  <label className="fileInput">
                    {!editPerfilState && (
                      <Button

                        style={{ color: "#FFF", backgroundColor: "#585858" }}
                        size="sm"
                        onClick={handleClickChangePhoto}
                      >
                        Mudar foto
                      </Button>
                    )}
                  </label>
                  <input
                    ref={photoInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
              </CardHeader>
              <CardBody className="pt-0 pt-md-4">
                <Row>
                  <div className="col">
                    <div className="card-profile-stats d-flex justify-content-center mt-md-5">
                    </div>
                  </div>
                </Row>
                <div className="text-center">
                  <h3>{CFC?.name}</h3>
                </div>
              </CardBody>
            </Card>
          </Col> */}
          <Col className="order-xl-1" xl="8">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <div className="col-6 xs-8">
                    <h3 className="mb-0">Minha conta</h3>
                  </div>
                  <Col className="text-right col-6" xs="4">
                    <Button
                      style={{ color: "#FFF", backgroundColor: "#585858" }}
                      onClick={(e) => setOpenModalChangePassword(true)}
                      size="sm"
                    >
                      Mudar senha
                    </Button>
                    {editPerfilState ? (
                      <>
                        <Button
                          style={{ color: "#FFF", backgroundColor: "#585858" }}
                          onClick={(e) => setEditPerfilState(false)}
                          size="sm"
                        >
                          Editar seu perfil
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          style={{ color: "#FFF", backgroundColor: "#585858" }}
                          onClick={() => handleSalveIndoInstituicao(instituicao)}
                          size="sm"
                        >
                          Salvar edições
                        </Button>
                        <Button
                          style={{
                            color: "#585858",
                            border: " 1px solid #585858",
                          }}
                          onClick={() => setEditPerfilState(true)}
                          size="sm"
                        >
                          Cancelar
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    INFORMAÇÃO DA INSTITUIÇÃO
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Nome completo
                          </label>
                          <Input
                            name="name"
                            value={instituicao?.name}
                            onChange={handleChange}
                            disabled={editPerfilState}
                            className="form-control-alternative"
                            id="input-first-name"
                            placeholder="Nome"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email
                          </label>
                          <Input
                            name="email"
                            value={instituicao?.email}
                            onChange={handleChange}
                            disabled
                            className="form-control-alternative"
                            id="input-email"
                            placeholder="exemple@example.com"
                            type="email"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-cnpj"
                          >
                            CNPJ
                          </label>
                          <Input
                            name="cnpj"
                            value={user?.office.cnpj}
                            onChange={handleChange}
                            disabled={editPerfilState}
                            className="form-control-alternative"
                            id="input-cnpj"
                            placeholder="CNPJ"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row> */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container >
      <ModalChangePassword
        openModal={openModalChangePassword}
        closeModal={() => setOpenModalChangePassword(false)}
      />
    </>
  );
};

export default ProfileInstituicao;